export const quantityInput = (el) => {
    let timer;

    el.once()
        .querySelectorAll("button")
        .forEach((btn) => {
            btn.addEventListener("click", function (e) {
                var $qty = btn.parentNode.querySelector("input"),
                    currentVal = parseFloat($qty.value),
                    max = parseFloat($qty.getAttribute("max")),
                    min = parseFloat($qty.getAttribute("min")),
                    step = $qty.getAttribute("step");

                // Format values
                if (!currentVal || currentVal === "" || currentVal === "NaN")
                    currentVal = 0;
                if (max === "" || max === "NaN") max = "";
                if (min === "" || min === "NaN") min = 0;
                if (
                    step === "any" ||
                    step === "" ||
                    step === undefined ||
                    parseFloat(step) === "NaN"
                )
                    step = 1;

                // Change the value
                if (btn.classList.contains("plus")) {
                    if (max && currentVal >= max) {
                        $qty.value = max;
                    } else {
                        $qty.value = (currentVal + parseFloat(step)).toFixed(
                            step.getDecimals(),
                        );
                    }
                } else {
                    if (min && currentVal <= min) {
                        $qty.value = min;
                    } else if (currentVal > 0) {
                        $qty.value = (currentVal - parseFloat(step)).toFixed(
                            step.getDecimals(),
                        );
                    }
                }

                clearTimeout(timer);
                timer = setTimeout(() => {
                    var event = new Event("change");
                    $qty.dispatchEvent(event);
                    jQuery($qty).trigger("change");
                }, 500);

                e.preventDefault();
                return false;
            });
        });

    el.classList.add("init");
};
